import { ListingResponseDTO } from "./shared"

export interface AccountOnboardingStateDTO {
	adaptiveHealingTooltipShown: number
	adaptiveMaskTooltipShown: number
	adaptiveCropTooltipShown: number
	adaptivePerspectiveTooltipShown: number
	calibrationTooltipsShown: number
	colorMatchAppliedToSuggestedShown: boolean
	continueReferenceReminderTooltipShown: number
	createStyleShown: boolean
	cullingShown: boolean
	cullingTooltipsShown: number
	manualCullingTooltipsShown: number
	expressSetupTooltipShown: number
	fullCalibrationTooltipsShown: number
	hiddenPhotosTooltipShown: boolean
	improveStyleTooltipsShown: number
	editingTooltipsShown: number
	intakeSurveyShown: boolean
	markReferenceReminderTooltipShown: number
	presetAppliedShown: boolean
	presetAppliedToSuggestedShown: boolean
	sessionCount: number
	unsubscribedSurveyShown: boolean
	welcomeCreditsShown: boolean
	welcomeShown: boolean
}

export interface UserSubscription {
	creditsIncluded: number
	creditsRemaining: number
	expiresAt: string
	startedAt: string
	status: string
	subscriptionId: string
	term: string
	tier: string
	hasUnlimitedExports: boolean
}

export interface UserPurchase {
	creditsPurchased: number
	creditsRemaining: number
	purchaseId: string
	purchasedAt: string
	status: string
}

export interface UserPromo {
	awardedAt: string
	expiresAt: string
	creditsAwarded: number
	creditsRemaining: number
	message: string
	promoId: string
	status: string
	promoType: string
}

export interface GenAiCreditPool {
	grantedAt: string
	creditsGranted: number
	creditsRemaining: number
	expiresAt: string
	message: string
	creditPoolId: string
	grantType: string
	status: string
}

export enum PixiesetAccountInfoStatus {
	Free = 0,
	Upgraded = 1,
	Expired = 2,
	Deleted = 3,
	Delinquent = 4,
}

export enum AppExperimentVariant {
	Off = "OFF",
	On = "ON",
}

export interface PixiesetSubscription {
	billingPlan: string
	accountInfoStatus: PixiesetAccountInfoStatus
}

export const isUserPartiallyInactive = (user?: GetUserResponseBody): boolean => {
	if (!user) {
		return false
	}
	const status = user.pixiesetSubscription?.accountInfoStatus
	return (
		status === PixiesetAccountInfoStatus.Expired ||
		status === PixiesetAccountInfoStatus.Delinquent ||
		status === PixiesetAccountInfoStatus.Deleted
	)
}

export interface GetAppConfigBody {
	localization: {
		electron: {
			enabledLocales: string[]
		}
		web: {
			enabledLocales: string[]
		}
	}
}

export interface GetUserResponseBody {
	experiments?: Record<string, AppExperimentVariant>
	externalId: string
	profilePictureUrl?: string
	promos?: UserPromo[]
	purchases?: UserPurchase[]
	subscriptions?: UserSubscription[]
	genAiCreditPools?: GenAiCreditPool[]
	totalCreditsAvailable: number
	totalGenAiCreditsAvailable: number
	userId: string
	displayName: string
	createdAt?: string
	role?: "User" | "Support" | "Staff" | "Automation" | "Admin"
	email: string
	emailVerified: boolean
	isWhitelisted: boolean
	hasUnlimitedExports: boolean
	migrationCompletedAt?: string | null
	onboardingState?: AccountOnboardingStateDTO
	businessName?: string
	pixiesetSubscription?: PixiesetSubscription
	preferredLocale: string
}

export interface UpdateUserRequestBody {
	profilePictureUrl?: string
	displayName?: string
	onboardingState?: AccountOnboardingStateDTO | null
}

export interface UserActivityEvent {
	eventTime: string
	eventType: string
	description: string
	amount: number
	subscriptionBalance: number
	payAsYouGoBalance: number
	totalBalance: number
	hasUnlimitedExports: boolean
}

export type FetchActivitiesResponseBodyDTO = ListingResponseDTO<UserActivityEvent>
